import React, { useState, useEffect, Component, Fragment } from "react";
import IntlMessages from "../helpers/IntlMessages";

export default function PersistentMenu({ menuOpen, persistentMenu, persistentMenuEnabled,
  handleMenuClick, botSettings, cookiesDetail, botSite }) {
  const mindate = new Date().getFullYear();
  const [currentYear, setCurrentYear] = useState(mindate)
  const MenuClick = (itemType, items) => {
    var data = {
      itemType: itemType,
      items: items
    }
    handleMenuClick(data);
  };
  const cookiesDetailClick = (url) => {
    cookiesDetail(url);
  };
  const BotSiteClick = (url) => {
    botSite(url);
  };
  return (
    <Fragment>
      {persistentMenu.length > 0 && (
        <div className="chat_box_popup_new" onClick={menuOpen}>
          <div className="menu_popup area">
            {persistentMenu.map((item, itemIndex) => (
              <div className="menu_popup_items" key={itemIndex}>
                {item.callToActions.filter((i)=>i.payLoad!=="select_property" && i.payLoad!=="switch_language" && i.payLoad!=="restart" && i.payLoad!=="hidebot").map((menu,menuIndex)=>(
                  <button className="popupmenu" key={menuIndex} onClick={() => MenuClick(menu.type, menu)}>
                    <span className="icon_text"></span>
                    <span className="text">
                      {menu.title}
                    </span>
                  </button>
                ))}
                {item.callToActions.filter((i) => i.payLoad === "select_property" || i.payLoad === "switch_language" || i.payLoad === "restart" || i.payLoad === "hidebot").map((menu, menuIndex) => (
                  <Fragment key={menuIndex}>
                    {menu.payLoad !== "switch_language" &&
                      <button className="popupmenu"  onClick={() => MenuClick(menu.type, menu)}>
                        {menu.payLoad === "select_property" &&
                          <Fragment>
                            <span className="property_icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z" />
                                <path d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z" />
                              </svg>
                            </span>
                            <span className="text"><IntlMessages id="switch.property" /></span>
                          </Fragment>
                        }
                        {menu.payLoad === "restart" &&
                          <Fragment>
                            <span className="restart_icon">
                              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                width="20.000000pt" height="20.000000pt" viewBox="0 0 512.000000 512.000000"
                                preserveAspectRatio="xMidYMid meet">

                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                  fill="currentColor" stroke="none">
                                  <path d="M2470 4617 c-19 -12 -43 -38 -54 -57 -21 -35 -21 -46 -24 -1063 -2 -737 1 -1040 9 -1070 16 -59 75 -114 134 -122 57 -9 129 24 162 74 l23 34 0 1061 c0 1041 0 1062 -20 1094 -30 49 -75 72 -141 72 -42 0 -65 -6 -89 -23z" />
                                  <path d="M1165 4146 c-91 -40 -123 -164 -64 -247 34 -48 87 -65 264 -84 88 -10 163 -21 168 -24 4 -4 -23 -29 -60 -57 -96 -70 -214 -183 -229 -221 -32 -74 -2 -168 66 -207 39 -23 122 -26 158 -7 13 7 52 39 88 71 75 68 185 152 191 147 2 -3 -6 -84 -18 -181 l-21 -176 23 -47 c13 -26 36 -56 50 -66 29 -21 103 -33 143 -23 32 8 83 51 101 85 18 35 109 792 100 837 -7 39 -46 89 -85 109 -26 14 -740 105 -813 105 -17 -1 -46 -7 -62 -14z" />
                                  <path d="M3130 3959 c-62 -26 -100 -85 -100 -154 0 -85 32 -122 159 -181 298 -139 574 -413 710 -705 49 -105 94 -237 118 -349 26 -123 26 -448 -1 -575 -125 -594 -585 -1051 -1176 -1165 -527 -103 -1080 99 -1423 518 -66 81 -101 102 -170 102 -52 0 -100 -29 -135 -80 -20 -29 -23 -44 -20 -92 5 -65 18 -87 123 -204 253 -282 605 -483 990 -564 129 -28 438 -38 582 -20 660 82 1235 534 1468 1155 131 351 149 749 51 1119 -132 498 -489 924 -964 1154 -97 47 -166 61 -212 41z" />
                                  <path d="M975 3115 c-165 -60 -138 -307 37 -331 62 -9 110 9 152 56 120 133 -20 337 -189 275z" />
                                  <path d="M844 2531 c-153 -70 -124 -294 42 -326 80 -15 170 42 194 122 24 80 -13 162 -90 201 -54 27 -92 28 -146 3z" />
                                  <path d="M903 1905 c-47 -29 -83 -92 -83 -146 1 -49 32 -112 70 -139 40 -28 126 -38 170 -20 73 30 123 128 101 200 -34 114 -158 165 -258 105z" />
                                </g>
                              </svg>
                            </span>
                            <span className="text">
                              <IntlMessages id="restart.converstation"></IntlMessages>
                            </span>
                          </Fragment>
                        }
                        {menu.payLoad === "hidebot" &&
                          <Fragment>
                            <span className="close_icon">
                              <svg version="1.1" width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" x="10px" y="10px" fill="currentColor"
                              >
                                <g>
                                  <g>
                                    <path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M327.115,365.904 L256,294.789l-71.115,71.115l-38.789-38.789L217.211,256l-71.115-71.115l38.789-38.789L256,217.211l71.115-71.115l38.789,38.789	L294.789,256l71.115,71.115L327.115,365.904z"/>
                                  </g>
                                </g>
                              </svg>
                            </span>
                            <span className="text"><IntlMessages id="chat.hidebot" /></span>
                          </Fragment>
                        }
                      </button>
                    }
                    {botSettings && botSettings.multilingual && menu.payLoad === "switch_language" &&
                      <button className="popupmenu" key={menuIndex} onClick={() => MenuClick(menu.type, menu)}>
                        <span className="language_icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M14.022,7h1a1.0013,1.0013,0,0,1,1,1V9a1,1,0,0,0,2,0V8a3.00328,3.00328,0,0,0-3-3h-1a1,1,0,0,0,0,2Zm-4,9h-1a1.0013,1.0013,0,0,1-1-1V14a1,1,0,0,0-2,0v1a3.00328,3.00328,0,0,0,3,3h1a1,1,0,0,0,0-2Zm11-1a1,1,0,0,0,0-2h-3v-.5a1,1,0,0,0-2,0V13h-3a1,1,0,0,0,0,2h5.18427a6.72756,6.72756,0,0,1-1.22553,2.52667,6.66828,6.66828,0,0,1-.62915-.98272.99972.99972,0,1,0-1.77929.9121,8.67791,8.67791,0,0,0,.9591,1.468A6.6182,6.6182,0,0,1,13.10645,20.023a1.00008,1.00008,0,0,0,.42675,1.9541,8.63506,8.63506,0,0,0,3.445-1.62164,8.72368,8.72368,0,0,0,3.46857,1.62115,1,1,0,1,0,.43066-1.95312,6.72477,6.72477,0,0,1-2.4461-1.09009A8.73637,8.73637,0,0,0,20.24371,15ZM9.05176,11.24268a1.00011,1.00011,0,0,0,1.94043-.48536L9.23486,3.72754a2.28107,2.28107,0,0,0-4.42578,0L3.05176,10.75732a1.00011,1.00011,0,0,0,1.94043.48536L5.5528,9H8.49115ZM6.0528,7l.69671-2.78711a.2913.2913,0,0,1,.54492,0L7.99115,7Z"></path>
                          </svg>
                        </span>
                        <span className="text"><IntlMessages id="switch.language" /></span>
                      </button>
                    }
                  </Fragment>
                ))}
              </div>
            ))}
            <div className="popup_bottombar">
              <div className="popup_bottombar_row">
                <a href=""
                  onClick={() => BotSiteClick("https://www.myma.ai/?utm_source=messenger&utm_medium=branding&utm_campaign=clicks")}
                >&copy; {currentYear} Myma ai, Inc.</a>
                <a className="page_link" href=""
                  onClick={() => BotSiteClick("https://www.myma.ai/privacy-policy?utm_source=messenger&utm_medium=branding&utm_campaign=clicks")}> Privacy</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}